<template>
  <div id="about">
    <div class="container_about">
      <div class="row">
          <div class="col-md-8 mt-3 fill">
          <!-- nav-tab -->
          <div class="row">
            <div class="col-md-12 flex-wrap">
              <nav>
                <div id="nav-tab" class="nav nav-tabs">
                  <ul class="list-group list-group-flush flex-row justify-content-center">
                    <li class="list-group-item p-0"><a id="about1" class="nav-item nav-link active" data-toggle="tab" href="#about-01">平台介紹</a></li>
                    <li class="list-group-item p-0"><a id="about2" class="nav-item nav-link" data-toggle="tab" href="#about-02">申請流程</a></li>
                    <li class="list-group-item p-0"><a id="about3" class="nav-item nav-link" data-toggle="tab" href="#about-03">最新消息</a></li>
                  </ul>
                </div>
              </nav>
            </div>
            <div class="tab-content bg-white p-3 overflow-auto" data-target="#nav-tab" style="height: 500px;">
              <div id="about-01" class="tab-pane fade show active">
              <h2>平台介紹</h2>
                <p>
                  彰化縣建城近三百年，城鄉空間具有深厚歷史文化底蘊，各地都保有因應族群生活、交通貿易、產業發展脈絡的特色建築，見證地方人民的生活軌跡
                </p>
                <p>
                  對於這些乘載彰化時光記憶的建築，除了透過文化資產的指定登錄，賦予其法定身分外，為保存歷史老屋，彰化縣政府也在尋找另一種可能，縣府在有限的資源條件下，積極向文化部爭取經費挹注，推動歷史老屋活化再利用補助計畫，由文化部及本縣提供經費，補助居民自行修繕或經營具有文化潛力之老屋，鼓勵民眾加入保存歷史老屋、活化閒置空間的行列，喚起民眾自發保存意識，另為與民眾交流更多老屋保存的觀念與經驗，也邀請具文資建築背景的專家團隊，提供相關諮詢及指導。
                </p>
                <p>
                  老屋修繕與維護是一條漫長的路，每個街區、每間老屋也建構出獨特的地方空間敘事，縣府透過歷史老屋活化再利用補助計畫，重新思考老屋與地方的關係，凝聚了在地文化保存發展的意識，期待藉由公私協力合作，以老屋空間作為時代記憶與文化傳承的重要載體，並將歷史老屋帶入地方的文化經濟循環，讓城鄉空間與人的故事可以傳遞述說。
                </p>
                <p>
                  本平台主要提供老屋屋主及想要經營老屋空間之民眾或單位，一個良好的交流平台，以及建置本縣歷史老屋活化再利用補助的各項申請資訊和歷史老屋活化的案例與故事，期盼在老屋供、需資訊的交流與公、私部門通力合作下，能吸引更多民眾投入老屋振興工作，並透過老屋的故事來認識彰化。
                </p>
            </div>
            <div id="about-02" class="tab-pane fade">
              <h2>申請流程</h2>
              <!-- part 1 -->
              <h5>一、彰化縣歷史老屋補助</h5>
              <p style="font-weight:500; margin-bottom:0;">
                申請日期：
              </p>
              <p>
                即日起至109年9月30日止。
              </p>
              <p style="font-weight:500">申請資格：</p>
              <ul>
                <li>1. 建築物位於彰化縣（不含鹿港鎮）。</li>
                <li>2. 民國60年（含）前興建完成。</li>
                <li>3. 不具法定文化資產身分。</li>
              </ul>
              <p style="font-weight:500">補助類別及金額：</p>
              <ul>
                <li>1. 小型修繕類：每案最高補助50萬元。</li>
                <li>2. 文化經營類：每案補助老屋承租人每月租金最高5,000元。</li>
              </ul>
              <!-- part 2 -->
              <h5>二、鹿港鎮歷史老屋補助</h5>
              <p>本縣已獲中央核定補助「千帆入港－再造鹿港歷史現場」專案計畫，為利經費有效利用，避免資源重複，鹿港地區的老屋修繕補助部分，將由該專案計畫給予歷史老屋活化再利用補助經費。另本計畫經費來源為文化部，如補助經費用罄，本計畫即終止。</p>
              <p style="font-weight:500; margin-bottom:0;">
                申請日期：
              </p>
                <p style="margin:o;">即日起至109年9月30日止。</p>
              <p style="font-weight:500">申請資格：</p>
              <ul>
                <li>1. 建築物位於彰化縣鹿港鎮。</li>
                <li>2. 民國60年（含）前興建完成。</li>
                <li>3. 不具法定文化資產身分。</li>
              </ul>
              <p style="font-weight:500">補助類別及金額：</p>
              <ul>
                <li>1. 小型修繕類：每案最高補助60萬元；如同意修繕後無償提供給文化局使用五年者，最高可補助90萬元。</li>
                <li>2. 文化經營類：每案補助老屋承租人每月租金最高8,000元。</li>
              </ul>
            </div>
            <div id="about-03" class="tab-pane fade">
              <h2>最新消息</h2>
              <h5>【徵】家有老屋想出租嗎？</h5>
              <p>
                發布日期：2020-08-10| 更新日期：2020-08-20|彰化縣
              </p>
              <p style="font-weight:500">
                徵家有老屋想出租嗎？
              </p>
              <p>
                想出租老屋❓ 正在找老屋❓
                「產業進駐老屋媒合平台」媒合了老屋的提供者與需求者，讓更多的老屋能結合創意迸發出新的想像。
              </p>
              <p style="font-weight:500">
                老屋資格｜要符合什麼條件才能上架？
              </p>
              <p>
                <ul>
                  <li>1、老屋位在 彰化縣</li>
                  <li>2、於民國60年前興建完成</li>
                </ul>
              </p>
              <p style="font-weight:500">
                老屋資格｜要符合什麼條件才能上架？
              </p>
              <p>
                <ul>
                  <li>1、填妥申請書</li>
                  <li>2、 專人協助上架</li>
                  <li>3、進行老屋媒合推廣</li>
                </ul>
              </p>
              <p>
                只要有位在彰化縣的老屋且在民國60年以前興建完成，都歡迎上架資訊至「老屋媒合平台」，一起看看目前有哪些老屋已經上架了呢 ?
              </p>
            </div>
            </div>

            <!--  nav-tab end -->
          </div>
        </div>
          <!-- img -->
          <div class="col-md-4 img-about">
            <img id="nav-img" class="w-100" src="../assets/oldhouse.jpg" style="object-fit:cover; border: 2px solid #333;" />
          </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {

}
</script>
<style>
@media(max-width:576px){
   /* About */
    #about{
      width: 100vw;
      height: 100%;
    }
    .container_about{
      padding-top: 10rem;
      padding-bottom: 2rem;
      margin: auto;
      width: 80%;
    }
    .img-about{
      margin-top: 2rem;
      text-align: center;
      margin-right: 1rem;
    }
}
@media (min-width: 578px) and (max-width: 768px) {
    #about{
      width: 100vw;
      height: 100%;
    }

    .container_about{
      padding-top: 10rem;
      padding-bottom: 5rem;
      margin: auto;
      width: 80%;
    }
}
@media(min-width:768px){
        #about{
            width: 100vw;
            height: 100%;
        }
        .container_about{
            padding-top: 20rem;
            padding-bottom: 5rem;
            margin: auto;
            max-width: 80%;
        }

        .img-about{
            margin-top: 3rem;
            display: flex;
            align-items: center;
        }

        #nav-img{
            height: 75%;
        }
  }
.nav-tabs {
  border-bottom: 0px solid #dee2e6 !important;
}
#about ul{
  padding-left: 0;
  list-style: none;
}
#about nav ul li a {
  color: rgb(93,155,132) !important;
}
#about-01{
  color: rgb(93,155,132) !important;
}
#about-02{
  color: rgb(93,155,132) !important;
}
#about-03{
  color: rgb(93,155,132) !important;
}

</style>
